import { TournamentState } from "../types/state";
import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { TalesTournament } from "../../../utils/types/TalesTournament";
import { LOADING } from "../../../types";

export const getTournamentState = (state: RootState): TournamentState =>
  state.tournament;

export const getTournamentData = createSelector(
  getTournamentState,
  (tournamentState): TalesTournament[] | null => tournamentState?.data,
);

export const getTournamentError = createSelector(
  getTournamentState,
  (tournamentState): string | null => tournamentState?.error,
);

export const isTournamentLoading = createSelector(
  getTournamentState,
  (tournamentState): boolean =>
    tournamentState?.loading === LOADING.PENDING ?? false,
);
